import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { SearchService, BasicSearchParams, ScrollService, UserService, ScrollParams } from '../api';
import { Router, NavigationExtras } from '@angular/router';
import * as _ from 'lodash';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {MdDialog, MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../';
import { SongsService} from '../api';
import { BreakPointsProvider } from '@angular/flex-layout';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  private searchTerm: string = '';
  private searchParams: BasicSearchParams = new BasicSearchParams();
  private myparams: BasicSearchParams = new BasicSearchParams();
  private myparams2: BasicSearchParams = new BasicSearchParams();
  private myparams3: BasicSearchParams = new BasicSearchParams();
  private myparams4: BasicSearchParams = new BasicSearchParams();
  private myparams5: BasicSearchParams = new BasicSearchParams();
  private myparams6: BasicSearchParams = new BasicSearchParams();
  private myparams7: BasicSearchParams = new BasicSearchParams();
  private results: any = new Array<any>();
  private results2: any = new Array<any>();
  private results3: any = new Array<any>();
  private results4: any = new Array<any>();
  private results5: any = new Array<any>();
  private results6: any = new Array<any>();
  private results7: any = new Array<any>();
  public autoCompleteData: any = new Array<any>();
  public autoCompleteData2: any = new Array<any>();
  public autoCompleteData3: any = new Array<any>();
  public autoCompleteData4: any = new Array<any>();
  lastkeydown1: number = 0;
  private loading: boolean = false;
  private mainSearch: boolean = true;
  arrow :any = true;
  arrow2 :any = true;
  arrow3 :any = true;
  arrow4 :any = true;
  arrow5 :any = true;
  arrow6 :any = true;
  arrow7 :any = true;
  emptyAutocomplete :any = false;
  @BlockUI() blockUI: NgBlockUI;
  dialogRef2: MdDialogRef<SongDetailComponent>;
  private song:any;
  public creditsArray: any = [];
  public writersArray: any = [];
  private limit: number = 20;
  private scrollParams = new ScrollParams();
  enableElasticSearch = false;

  constructor(private searchService: SearchService,private songService: SongsService,public dialog: MdDialog, private cdRef: ChangeDetectorRef, private router: Router,
    private scrollService: ScrollService, private userService: UserService) {
  }

  ngOnInit() {
    this.userService.getUserEventEmitter().subscribe((item) => {
      if (item.name === 'user:login') {
        this.searchService.getSearchPreferences().subscribe((res) => {
          localStorage.setItem('searchPreferences', JSON.stringify(res));
          this.searchParams.processPreferences();
          this.searchTerm = '';
          this.results = new Array<any>();
          this.results2 = new Array<any>();
          this.results3 = new Array<any>();
          this.results4 = new Array<any>();
          this.results5 = new Array<any>();
          this.results6 = new Array<any>();
          this.results7 = new Array<any>();
          this.loading = false;
          this.cdRef.detectChanges();
        });
      } else if (item.name === 'user:logout') {
        this.searchParams.processPreferences();
        this.searchTerm = '';
        this.results = new Array<any>();
        this.results2 = new Array<any>();
        this.results3 = new Array<any>();
        this.results4 = new Array<any>();
        this.results5 = new Array<any>();
        this.results6 = new Array<any>();
        this.results7 = new Array<any>();
        this.loading = false;
        this.scrollService.closeSideNav();
        this.cdRef.detectChanges();
      }
      this.searchTerm = '';
      this.results = new Array<any>();
    },
    (error) => {
      console.log(error);
    });
    this.searchParams.processPreferences();
    var input = document.getElementById("myInput");
    input.addEventListener("keyup", function(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        document.getElementById("myBtn").click();
      }
    });
    this.scrollService.enableScrollIfDisabled();
  }

  search() {
    this.emptyAutocomplete = true;
    var mainUiinner1 = document.getElementById("Ui12345");
    if(mainUiinner1){
    mainUiinner1.style.visibility = "visible";
    }
    var mainUiinner2 = document.getElementById("Ui123456");
    if(mainUiinner2) {
      mainUiinner2.style.visibility = "visible";
    }
    var mainUi = document.getElementById("Ui1234");
    if(mainUi) {
      mainUi.style.visibility = "hidden";
    }
    if (this.searchTerm !== '') {
      this.blockUI.start('Loading, please wait...');

      this.arrow = true;
      this.arrow2 = true;
      this.arrow3 = true;
      this.arrow4 = true;
      this.arrow5 = true;
      this.arrow6 = true;
      this.arrow7 = true;
      this.results = new Array<any>();
      this.results2 = new Array<any>();
      this.results3 = new Array<any>();
      this.results4 = new Array<any>();
      this.results5 = new Array<any>();
      this.results6 = new Array<any>();
      this.results7 = new Array<any>();

      this.myparams2.searchArtists = false;
      this.myparams.searchSongs = false;
      this.myparams3.searchCollections = false;
      this.myparams4.searchPlaylists = false;
      this.myparams5.searchUsers = false;
      this.myparams6.searchLike = false;
      this.myparams7.searchCredits = false;
      this.searchParams.query = this.searchTerm;
      if (this.searchParams.searchSongs) {
        this.myparams.searchSongs = true;
        this.myparams.searchArtists = false;
        this.myparams.searchCollections = false;
        this.myparams.searchPlaylists = false;
        this.myparams.searchUsers = false;
        this.myparams.searchLike = false;
        this.myparams.searchCredits = false;
      }
      if (this.searchParams.searchArtists) {

        this.myparams2.searchSongs = false;
        this.myparams2.searchArtists = true;
        this.myparams2.searchCollections = false;
        this.myparams2.searchPlaylists = false;
        this.myparams2.searchUsers = false;
        this.myparams2.searchLike = false;
        this.myparams2.searchCredits = false;
      }
      if (this.searchParams.searchCollections) {
        this.myparams3.searchSongs = false;
        this.myparams3.searchArtists = false;
        this.myparams3.searchCollections = true;
        this.myparams3.searchPlaylists = false;
        this.myparams3.searchUsers = false;
        this.myparams3.searchLike = false;
        this.myparams3.searchCredits = false;
      }
      if (this.searchParams.searchPlaylists) {
        this.myparams4.searchSongs = false;
        this.myparams4.searchArtists = false;
        this.myparams4.searchCollections = false;
        this.myparams4.searchPlaylists = true;
        this.myparams4.searchUsers = false;
        this.myparams4.searchLike = false;
        this.myparams4.searchCredits = false;
      }
      if (this.searchParams.searchUsers) {
        this.myparams5.searchSongs = false;
        this.myparams5.searchArtists = false;
        this.myparams5.searchCollections = false;
        this.myparams5.searchPlaylists = false;
        this.myparams5.searchUsers = true;
        this.myparams5.searchLike = false;
        this.myparams5.searchCredits = false;
      }

      if (this.searchParams.searchLike) {
        this.myparams6.searchSongs = false;
        this.myparams6.searchArtists = false;
        this.myparams6.searchCollections = false;
        this.myparams6.searchPlaylists = false;
        this.myparams6.searchUsers = false;
        this.myparams6.searchCredits = false;
        this.myparams6.searchLike = true;
      }

      if (this.searchParams.searchCredits) {
        this.myparams7.searchSongs = false;
        this.myparams7.searchArtists = false;
        this.myparams7.searchCollections = false;
        this.myparams7.searchPlaylists = false;
        this.myparams7.searchUsers = false;
        this.myparams7.searchCredits = true;
        this.myparams7.searchLike = false;
      }
      this.loading = true;

      let dataValue = (<HTMLInputElement>document.getElementById('myInput-input')).value;
      let songsnamesdata = [];
      let artistsnamesdata = [];
      let playlistsnamesdata = [];
      let collectionsnamesdata = [];
      let usersnamesdata = [];
      let soundslikedata = [];
      let productioncreditsdata = [];
      let productioncreditsdata2 = [];

      // for songs
      if(this.myparams.searchSongs) {
        this.results = new Array<any>();
        this.songService.getSongsfromdb(dataValue).toPromise().then((res) => {
          songsnamesdata = res['songs'];
          if(!res['songs'] && this.enableElasticSearch) {
            this.searchService.getSearchResults(this.searchTerm, this.myparams).then((res) => {
              if(res) {
                if(res.data && res.data['song']) {
                  var i = 0;
                  res.data['song'].forEach((arrayItem) => {
                    let song: any = _.pick(arrayItem._source, ['name', 'artist', 'album', 'slug','id']);
                    song._type = arrayItem._type;
                    this.results['song'][i] = song;
                    i++;
                  });
                  if(this.results.length > 0)
                    this.results.sort(function(a, b){
                      return a.name.length-b.name.length;
                    });
                    this.loading = false;
                } else {
                  this.loading = false;
                }
              }
            });
          }
          
          // concatinate the results from MySQL and elastic search
          this.results = [].concat(this.results, songsnamesdata)
          this.results = _.uniqBy(this.results, 'id');
          this.results = _.groupBy(this.results, '_type');
          
          // check if song array exists
          if(this.results.song) {
            this.myparams.totalResults = res['totalCount'];
          } else {
            this.results.song = [];
          }
          this.blockUI.stop();
        });
      }

      // for artist
      if (this.myparams2.searchArtists) {
        this.songService.getArtistsfromdb(dataValue).toPromise().then((res) => {
          artistsnamesdata = res['artists'];
          if(!res['artists'] && this.enableElasticSearch) {
            this.searchService.getSearchResults(this.searchTerm, this.myparams2).then((res) => {
              if (res) {
                if (res.data && res.data['artist']) {
                  var i = 0;
                  res.data['artist'].forEach((arrayItem) => {
                    let artist: any = _.pick(arrayItem._source, ['name', 'image', 'slug']);
                    artist._type = arrayItem._type;
                    this.results2['artist'][i] = artist;
                    i++;
                  });
                  if(this.results2.length > 0)
                    this.results2.sort(function(a, b){
                      return a.name.length-b.name.length;
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
              }
            });
          }
          // concatinate the results from MySQL and elastic search
          this.results2 = [].concat(this.results2 ,artistsnamesdata)
          this.results2 = _.uniqBy(this.results2, 'id');
          this.results2 = _.groupBy(this.results2, '_type');

          // check if artist array exists
          if(this.results2.artist) {
            this.myparams2.totalResults = res['totalCount'];
          } else {
            this.results2.artist = [];
          }
          this.blockUI.stop();
        });
      }

      // for collection
      if (this.myparams3.searchCollections) {
        let quickSearch:string = 'yes';
        this.songService.getCollectionsfromdb(dataValue, quickSearch).toPromise().then((res) => {
          collectionsnamesdata = res['collections'];
          if(!res['collections'] && this.enableElasticSearch) {
            this.searchService.saveSearchQuery(this.myparams3).subscribe((res) => { });
            this.loading = true;
            this.searchService.getSearchResults(this.searchTerm, this.myparams3).then((res) => {
              if(res) {
                if (res.data && res.data['album']) {
                  var i = 0;
                  res.data['album'].forEach((arrayItem) => {
                    let album: any = _.pick(arrayItem._source, ['name', 'image', 'slug']);
                    album._type = arrayItem._type;
                    this.results3['album'][i] = album;
                    i++;
                  });
                  if(this.results3.length > 0)
                    this.results3.sort(function(a, b){
                      return a.name.length-b.name.length;
                    });
                    this.loading = false;
                } else {
                  this.loading = false;
                }
              }
            });
          }
          // concatinate the results from MySQL and elastic search
          this.results3 = [].concat(this.results3 ,collectionsnamesdata)
          this.results3 = _.uniqBy(this.results3, 'id');
          this.results3 = _.groupBy(this.results3, '_type');
          
          // check if album array exists
          if(this.results3.album) {
            this.myparams3.totalResults = res['totalCount'];
          } else {
            this.results3.album = [];
          }
          this.blockUI.stop();
        });
      }

      // for playlist
      if (this.myparams4.searchPlaylists) {
        let quickSearch:string = 'yes';
        this.songService.getPlaylistfromdb(dataValue, quickSearch).toPromise().then((res) => {
          playlistsnamesdata = res['playlists'];
          if(!res && this.enableElasticSearch) {
            this.searchService.getSearchResults(this.searchTerm, this.myparams4).then((res) => {
              if(res) {
                this.myparams4.totalResults = res.total;
                if (res.data && res.data['playlist']) {
                  res.data['playlist'].forEach((arrayItem) => {
                    let playlist: any = arrayItem._source;
                    playlist._type = arrayItem._type;
                    if(typeof this.results4.push == "function") {
                      this.results4.push(playlist);
                    }
                  });
                  if(this.results4.length > 0)
                    this.results4.sort(function(a, b){
                      return a.name.length-b.name.length;
                    });
                    this.loading = false;
                } else {
                  this.loading = false;
                }
              }
            });
          };
          // concatinate the results from MySQL and elastic search
          this.results4 = [].concat(this.results4, playlistsnamesdata)
          this.results4 = _.uniqBy(this.results4, 'id');
          this.results4 = _.groupBy(this.results4, '_type');
          
          // check if playlist array exists
          if(this.results4.playlist) {
            this.myparams4.totalResults = res['totalCount'];
          } else {
            this.results4.playlist = [];
          }
          this.blockUI.stop();
        });
      }

      // for users
      if(this.myparams5.searchUsers) {
        this.songService.getUsersfromdb(dataValue).toPromise().then((res) => {
          usersnamesdata = res['users'];
          if(!res['users'] && this.enableElasticSearch) {
            this.searchService.getSearchResults(this.searchTerm, this.myparams5).then((res) => {
              if (res) {
                this.myparams5.totalResults = res.total;
                if (res.data && res.data['account']) {
                  res.data['account'].forEach((arrayItem) => {
                    let account: any = _.pick(arrayItem._source, ['screenname']);
                    account._type = arrayItem._type;
                    if(typeof this.results5.push == "function") {
                      this.results5.push(account);
                    }
                  });
                  if(this.results5.length>0)
                    this.results5.sort(function(a, b){
                      return a.screenname.length-b.screenname.length;
                    });
                    this.loading = false;
                } else {
                  this.loading = false;
                }
              }
            });
          };
          // concatinate the results from MySQL and elastic search
          this.results5 = [].concat(this.results5, usersnamesdata)
          this.results5 = _.uniqBy(this.results5, 'screenname');
          this.results5 = _.groupBy(this.results5, '_type');
          // check if account array exists
          if(this.results5.account) {
            this.myparams5.totalResults = res['totalCount'];
          } else {
            this.results5.account = [];
          }
          this.blockUI.stop();
        });
      }

      // for search like
      if (this.myparams6.searchLike) {
        this.results6 = new Array<any>();
        let quickSearch = "yes";
        this.songService.getSoundsLikefromdb(this.searchTerm, quickSearch).subscribe(res => {
          soundslikedata =  res['songs'];
          if(!res['songs'] && this.enableElasticSearch) {
            this.searchService.getSearchResults(this.searchTerm, this.myparams6).then((res) => {
              if (res) {
                this.myparams6.totalResults = res.total;
                if (res.data && res.data['song']) {
                  res.data['song'].forEach((arrayItem) => {
                    let song: any = _.pick(arrayItem._source, ['name', 'artist', 'album', 'slug','id']);
                    song._type = arrayItem._type;
                    if(typeof this.results6.push == "function"){
                      this.results6.push(song);
                    }
                  });
                  if(this.results6.length > 0)
                    this.results6.sort(function(a, b){
                      return a.name.length-b.name.length;
                    });
                  this.loading = false;
                } else {
                  this.loading = false;
                }
              }
            });
          }
          // concatinate the results from MySQL and elastic search
          this.results6 = [].concat(this.results6, soundslikedata)
          this.results6 = _.uniqBy(this.results6, 'id');
          this.results6 = _.groupBy(this.results6, '_type');
          this.loading = false;

          // check if song array exists
          if(this.results6.song) {
            this.myparams6.totalResults = res['totalCount'];
          } else {
            this.results6.song = [];
          }
          this.blockUI.stop();
        })
      }

      // for search credit
      if (this.myparams7.searchCredits) {
        this.results7 = new Array<any>();
        this.songService.getSongsfromlblwrtrpblsh(dataValue, this.limit,this.scrollParams.page).toPromise().then((res) => {
          productioncreditsdata2 = res.songs;
          if (res) {
            this.myparams7.totalResults = res.total;
          }
          productioncreditsdata2.forEach((arrayItem) => {
            let song: any = _.pick(arrayItem.song, ['name', 'artist', 'album', 'slug','id']);
            song._type = "song";
            if(typeof this.results7.push == "function"){
              if(song.name){
                this.results7.push(song);
              }
            }
          });

          this.searchService.getSearchResults(this.searchTerm, this.myparams7).then((res) => {
            if(res.total > this.myparams7.totalResults){
              this.myparams7.totalResults = res.total;
            }
            if (res.data && res.data['song']) {
              res.data['song'].forEach((arrayItem) => {
                let song: any = _.pick(arrayItem._source, ['name', 'artist', 'album', 'slug','id']);
                song._type = arrayItem._type;
                if(typeof this.results7.push == "function"){
                  if(song.name){
                    this.results7.push(song);
                  }
                }
              });
              if(this.results5.length>0)
                this.results7.sort(function(a, b){
                  return a.name.length-b.name.length;
                });
              this.loading = false;
            } else {
              this.loading = false;
            }
            this.results7 = [].concat(this.results7 ,productioncreditsdata ,productioncreditsdata2)
            this.results7 = _.uniqBy(this.results7, 'name');
            this.results7 = _.groupBy(this.results7, '_type');
            this.blockUI.stop();
          });
        });
      }
      this.cdRef.detectChanges();
      if(!this.myparams.searchSongs && !this.myparams2.searchArtists && !this.myparams3.searchCollections && !this.myparams7.searchCredits && !this.myparams6.searchLike && !this.myparams5.searchUsers && !this.myparams4.searchPlaylists){
        this.blockUI.stop();
      }
    }
  }

  handleSearch(event) {
    this.search();
  }

  navigate(type: string,subtype:string="") {
    this.scrollService.closeSideNav();
    if(subtype == ""){
      subtype = "search";
    }
    let navigationExtras: NavigationExtras = {
      queryParams: { 'q': this.searchTerm,'type': subtype},
    };
    if (type === 'songs') {
      this.router.navigate(['/songs'], navigationExtras);
    } else if (type === 'artists') {
      this.router.navigate(['/artists'], navigationExtras);
    } else if (type === 'albums') {
      this.router.navigate(['/collections'], navigationExtras);
    } else if (type === 'playlists') {
      this.router.navigate(['/peoples-playlists'], navigationExtras);
    } else if (type === 'account') {
      this.router.navigate(['/accounts'], navigationExtras);
    }
  }

  closeSearchSidenav(event, route) {
    event.stopPropagation();
    event.preventDefault();
    this.scrollService.closeSideNav();
    this.searchService.setLastSearch(route);
  }

  openSongDetail(song) {
    this.blockUI.start('Loading, please wait...');
    if(song && song.id) {
      this.songService.getSongDetailBySlug(song.id).subscribe((res) => {
        this.song = res;
      }, (error) => {
        console.log(error);
      });
    }
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    setTimeout(()=>{
      this.dialogRef2 = this.dialog.open(SongDetailComponent, {
        width: width
      });
      this.dialogRef2.componentInstance.slug = this.song.slug;
      return false;
    },2000)
  }

  getUserIdsFirstWay($event) {
    let dataValue = (<HTMLInputElement>document.getElementById('myInput-input')).value;
    let songsnamesdata = [];
    let artistsnamesdata = [];
    let playlistsnamesdata = [];
    let collectionsnamesdata = [];
    let usersnamesdata = [];
    let soundslikedata = [];
    let productioncreditsdata = [];
    if (dataValue.length > 1) {
      if (this.searchParams.searchSongs || this.searchParams.searchCredits || this.searchParams.searchArtists || this.searchParams.searchPlaylists || this.searchParams.searchCollections || this.searchParams.searchUsers || this.searchParams.searchLike ) {
        this.emptyAutocomplete = false;
        this.songService.getAllsongsname (dataValue , this.searchParams.searchSongs , this.searchParams.searchCredits , this.searchParams.searchArtists , this.searchParams.searchPlaylists , this.searchParams.searchCollections , this.searchParams.searchUsers , this.searchParams.searchLike).toPromise().then((res) => {
          let songsnames = JSON.stringify(res);
          this.autoCompleteData = this.searchFromArray(JSON.parse(songsnames), dataValue);
          let uniqueArray = (names) => names.filter((v,i) => names.indexOf(v) === i);
          this.autoCompleteData = uniqueArray(this.autoCompleteData);
        });
      }
    } else {
      this.autoCompleteData = [];
    }
  }

  searchFromArray(arr, regex) {
    let matches = [], i, count=0;
    for (i = 0; i < arr.length; i++) {
      if (arr[i].name != null) {
        matches.push(arr[i].name);
        count++;
        if(count == 50){
          return matches;
        }
      }
    }
    return matches;
  };

  onClear() {
    this.searchTerm = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/search/search.component.ts